/*
 * Copyright (c) Nexign, JSC, 2021.
 */
/**
 * Widget Multi Balances Actions
 *
 * @author Aleksandr Perkhunov
 * @version 1.10.0
 * @since 1.10.0
 */

import { createAction } from '../../../../../modules/app/createAction';
import {
    WIDGET_MULTI_BALANCES_GET_LIST_FAILURE,
    WIDGET_MULTI_BALANCES_GET_LIST_START,
    WIDGET_MULTI_BALANCES_GET_LIST_SUCCESS,
} from './widgetMultiBalancesConstants';
import {
    IWidgetMultiBalancesGetListSuccessPayload,
    TWidgetMultiBalancesGetListAction,
    TWidgetMultiBalancesGetListFailure,
    TWidgetMultiBalancesGetListSuccess,
} from './widgetMultiBalancesTypes';

export const widgetMultiBalancesGetListAction = (): TWidgetMultiBalancesGetListAction =>
    createAction(WIDGET_MULTI_BALANCES_GET_LIST_START);

export const widgetMultiBalancesGetListSuccess =
    (payload: IWidgetMultiBalancesGetListSuccessPayload): TWidgetMultiBalancesGetListSuccess =>
        createAction(WIDGET_MULTI_BALANCES_GET_LIST_SUCCESS, payload);

export const widgetMultiBalancesGetListFailure = (payload: string): TWidgetMultiBalancesGetListFailure =>
    createAction(WIDGET_MULTI_BALANCES_GET_LIST_FAILURE, payload);
